module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoice-page mx-auto"
  }, [_c('div', {
    staticClass: "container-fluid bg-light"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.company.name))]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.company.address) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("PIB")]), _vm._v(" " + _vm._s(_vm.company.taxNumber) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Matični broj")]), _vm._v(" " + _vm._s(_vm.company.registrationNumber) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Tekući račun")]), _vm._v(" " + _vm._s(_vm.company.bankAccount) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [(_vm.invoice.client) ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.invoice.client.name))]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.invoice.client.address) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("PIB")]), _vm._v(" " + _vm._s(_vm.invoice.client.taxNumber) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Matični broj")]), _vm._v(" " + _vm._s(_vm.invoice.client.registrationNumber) + "\n\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center pt-4"
  }, [_c('div', {
    staticClass: "col-7"
  }, [_c('h1', {
    staticClass: "display-number"
  }, [_vm._v(_vm._s((_vm.invoice.type === 'proinvoice') ? 'Predračun' : 'Račun') + " "), _c('strong', [_vm._v(_vm._s(_vm.invoice.number))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('p', [_c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Datum izdavanja")]), _vm._v(" " + _vm._s(_vm._f("date")(_vm.invoice.issueDate)) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Mesto izdavanja")]), _vm._v(" " + _vm._s(_vm.invoice.issuePlace) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoice.type === 'invoice'),
      expression: "invoice.type === 'invoice'"
    }]
  }, [_c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Datum prometa")]), _vm._v(" " + _vm._s(_vm._f("date")(_vm.invoice.deliveryDate))), _c('br')]), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Rok za plaćanje")]), _vm._v(" " + _vm._s(_vm._f("date")(_vm.invoice.paymentDeadline)) + "\n\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.invoice.items), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.price)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.total)))])])
  }), 0)]), _vm._v(" "), _c('h5', {
    staticClass: "text-right"
  }, [_vm._v("Ukupno "), _c('span', {
    staticClass: "badge badge-secondary badge-price"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.invoice.total)))])]), _vm._v(" "), (_vm.advancePayments.length > 0) ? _c('div', {
    staticClass: "text-right pt-3"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Avansne uplate:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.advancePayments), function(payment) {
    return _c('li', {
      staticClass: "list-inline-item"
    }, [_vm._v(_vm._s(_vm._f("date")(payment.date)) + " "), _c('strong', [_vm._v(_vm._s(_vm._f("money")(payment.amount)))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company.responsiblePerson),
      expression: "company.responsiblePerson"
    }],
    staticClass: "text-right pt-5"
  }, [_c('p', [_c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Odgovorno lice:")]), _vm._v(" " + _vm._s(_vm.company.responsiblePerson))])]), _vm._v(" "), _c('div', {
    staticClass: "text-right pt-1"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoice.note),
      expression: "invoice.note"
    }],
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.invoice.note))]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('footer', {
    staticClass: "fixed-bottom bg-dark text-light text-center small font-weight-light"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.company.email))]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.company.phoneNumber))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('img', {
    staticClass: "img-logo mb-2",
    attrs: {
      "src": require("../assets/logo2.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Naziv usluge")]), _vm._v(" "), _c('th', [_vm._v("Količina")]), _vm._v(" "), _c('th', [_vm._v("Cena")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Ukupno")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small text-muted"
  }, [_vm._v("Račun je punovažan bez pečata i potpisa."), _c('br'), _vm._v("Izdavalac računa nije obaveznik PDV-a po članu 33. Zakona o PDV.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('span', [_vm._v("·")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08e3bd4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvoicePreview.vue
// module id = 290
// module chunks = 1